import { useState } from 'react'
import { useVerificationFlow } from '../../../Components/shared/VerificationFlow'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../store'
import { verifyTeamMembership } from '../../../store/slices/homebotNetwork/clientTeamMemberships'
import { usePrequalRequest } from '../../usePrequalRequest'
import { selectHomeId } from '../../../store/selectors/home'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import * as Sentry from '@sentry/browser'
import { Listing } from '../../../api/gqlaxy/gql/generated/graphql'

export const useVerificationPrequalStep = (listing?: Listing) => {
  const dispatch = useDispatch<AppDispatch>()
  const { state, dispatch: dispatchVerificationFlow } = useVerificationFlow()
  const { sendPrequal, sendPrequalForListing, isLoading: isSendingPrequal } = usePrequalRequest()
  const [isLoading, setIsLoading] = useState(false)

  const membership = state.loanOfficerMembership
  const homeId = useSelector(selectHomeId)
  const topicKey = homeId
    ? CUSTOMER_MESSAGES.HBN_HOMEOWNER_PREQUAL_REQUEST.topicKey
    : CUSTOMER_MESSAGES.HBN_BUYER_PREQUAL_REQUEST.topicKey
  const topic = homeId
    ? CUSTOMER_MESSAGES.HBN_HOMEOWNER_PREQUAL_REQUEST.topic
    : CUSTOMER_MESSAGES.HBN_BUYER_PREQUAL_REQUEST.topic

  // TBD
  const message =
    state.message ||
    (homeId
      ? CUSTOMER_MESSAGES.HBN_HOMEOWNER_PREQUAL_REQUEST.message.defaultMessage
      : CUSTOMER_MESSAGES.HBN_BUYER_PREQUAL_REQUEST.message.defaultMessage)

  const onSkip = () => {
    dispatchVerificationFlow({ type: 'CANCEL' })
  }

  const onRemove = () => {
    dispatchVerificationFlow({ type: 'REMOVE_PARTNER' })
  }

  const verifyAndSendPrequal = async () => {
    setIsLoading(true)
    try {
      // First, verify the team membership
      await dispatch(
        verifyTeamMembership({
          clientId: membership.clientId,
          clientTeamMembershipId: membership.id
        })
      ).unwrap()

      /**
       * If a listing is provided and the customer is a loan officer,
       * send the normal prequal request. Otherwise, we will have to
       * fire the new one that goes to the preferred loan officer.
       */
      if (listing && state.customerIsLoanOfficer) {
        await sendPrequalForListing({ listing })
      } else {
        await sendPrequal({ topic, topicKey, message })
      }
    } catch (error) {
      Sentry.captureException(error)
      throw error
    } finally {
      dispatchVerificationFlow({ type: 'PREQUAL_SENT' })
      setIsLoading(false)
    }
  }

  return {
    onSkip,
    onRemove,
    verifyAndSendPrequal,
    isLoading: isLoading || isSendingPrequal,
    membership
  }
}
